import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 75px;
  width: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 20px;

  @media (max-width: 800px) {
    bottom: 0;
  }
`;

export const Container = styled.div`
  height: 100%;
  width: 400px;
  background: ${props =>
    props.theme.colors.white === '#ffffff'
      ? 'var(--primary)'
      : 'var(--white-darker)'};
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px -10px 50px rgba(0, 0, 0, 0.25);

  @media (max-width: 800px) {
    width: 100%;
    border-radius: 0;
  }
`;

interface IButton {
  selected: boolean;
}

export const Button = styled.button<IButton>`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: none;
  outline: none;
  cursor: pointer;

  background: transparent;
  color: ${props =>
    props.selected
      ? props.theme.colors.white === '#ffffff'
        ? 'var(--white)'
        : 'var(--primary)'
      : 'var(--gray-9)'};

  > span {
    font-size: 12px;
    font-weight: 500;
    margin-top: 2px;
  }
`;

export const WhiteSpace = styled.div`
  height: 95px;

  @media (max-width: 800px) {
    height: 115px;
  }
`;
